import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-placanje-starih-racuna',
  templateUrl: './placanje-starih-racuna.component.html',
  styleUrls: ['./placanje-starih-racuna.component.scss']
})
export class PlacanjeStarihRacunaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
